import { Component, Input, OnInit } from '@angular/core';
import { NewsfeedNotification } from '../../classes';

@Component({
  selector: 'app-newsfeed-notification',
  templateUrl: './newsfeed-notification.component.html',
  styleUrls: ['./newsfeed-notification.component.css']
})
export class NewsfeedNotificationComponent implements OnInit {

  @Input() newsfeedNotification: NewsfeedNotification;

  constructor() { }

  log = () => console.log(this.newsfeedNotification);

  ngOnInit(): void {
  }

}
